export let Screen;
(function (Screen) {
  Screen["TICKET_DETAILS"] = "ticket-details";
  Screen["TICKET_LISTINGS"] = "ticket-listings";
})(Screen || (Screen = {}));
const ticketDetailsPathPattern = /\/ticket\/[^/]+(?:\/[^/]+)*\/?$/;
export const getScreen = (pathname = window.location.pathname) => {
  return ticketDetailsPathPattern.test(pathname) ? Screen.TICKET_DETAILS : Screen.TICKET_LISTINGS;
};